import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Beneficiario } from '../model/beneficiarios.model';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BeneficiarioService {
  private apiUrl =  `${environment.apiUrl}/api/beneficiarios`; 


  constructor(private http: HttpClient) {}

  private manejarError(error: HttpErrorResponse): Observable<never> {
    console.error('❌ Error en la petición:', error);
    let mensaje = 'Ocurrió un error inesperado.';

    if (error.status === 400) {
      mensaje = error.error.message || 'Datos inválidos.';
    } else if (error.status === 401) {
      mensaje = 'No estás autenticado. Inicia sesión nuevamente.';
      Swal.fire({
        icon: 'warning',
        title: 'Sesión expirada',
        text: mensaje,
        confirmButtonText: 'Ir al login'
      }).then(() => {
        window.location.href = '/login';
      });
      return throwError(() => new Error(mensaje));
    } else if (error.status === 403) {
      mensaje = 'No tienes permisos para realizar esta acción.';
    } else if (error.status === 404) {
      mensaje = 'El beneficiario no fue encontrado.';
    } else if (error.status === 409) {
      mensaje = 'El beneficiario ya está registrado.';
    } else if (error.status === 500) {
      mensaje = 'Error en el servidor. Inténtalo más tarde.';
    }

    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: mensaje
    });

    return throwError(() => new Error(mensaje));
  }

  getBeneficiarios(): Observable<Beneficiario[]> {
    return this.http.get<Beneficiario[]>(this.apiUrl, { withCredentials: true }).pipe(
      catchError(this.manejarError)
    );
  }

  updateBeneficiario(documento: number, data: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${documento}`, data, { withCredentials: true }).pipe(
      catchError(this.manejarError)
    );
  }

  createBeneficiario(data: any): Observable<any> {
    return this.http.post(this.apiUrl, data, { withCredentials: true }).pipe(
      catchError(this.manejarError)
    );
  }

  deleteBeneficiario(documento: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${documento}`, { withCredentials: true }).pipe(
      catchError(this.manejarError)
    );
  }
}
